export default {"src":"/_next/static/media/exploring.colour.47cc34e4.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};